<template>
  <form id="detailInfoModal">
    <b-modal
      v-model="show"
      :title="workerId"
      modal-class="spdo-modal"
      hide-header-close
      hide-footer
      centered
      size="lg"
      @hide="hideModal"
    >
      <div class="v-application spdo-modal__body pt-4 break-word">
        <div
          v-if="isCreation"
          class="input-block input-block_white"
        >
          <v-textarea
            v-model="message"
            autocomplete="off"
            hide-details
            solo
          />
        </div>
        <vue-json-pretty
          v-if="(isCreation && parsedMessage) || (detailInfo && detailInfo.data)"
          :deep="2"
          show-length
          :select-on-click-node="false"
          :data="isCreation ? parsedMessage : detailInfo.data"
        />
        <div
          v-else
          class="d-flex py-4"
        >
          <span class="mx-auto">Нет данных</span>
        </div>
      </div>
      <div class="v-application d-flex mt-4 sticky-bottom">
        <v-btn
          v-if="isCreation"
          color="primary"
          class="mr-4 flex-grow-1"
          outlined
          large
          :loading="loading"
          @click="createMessage"
        >
          {{ $t('common.create') }}
        </v-btn>

        <v-btn
          color="primary"
          class="mr-4 flex-grow-1"
          outlined
          large
          @click="hideModal"
        >
          {{ $t('common.close') }}
        </v-btn>
      </div>
    </b-modal>
  </form>
</template>

<script>
import 'vue-json-pretty/lib/styles.css';

export default {
  name: 'DetailInfoModal',
  props: {
    value: Boolean,
    detailInfo: Object,
    isCreation: Boolean,
    isReschedule: Boolean,
    workerId: String,
  },
  data: () => ({
    show: false,
    message: '',
    loading: false,
  }),
  computed: {
    parsedMessage() {
      return this.message ? JSON.parse(this.message) : '';
    },
  },
  watch: {
    value(val) {
      this.show = val;
      this.message = '';
      if (this.isReschedule) {
        this.message = JSON.stringify(this.detailInfo);
      }
      this.loading = false;
    },
  },
  methods: {
    createMessage() {
      this.$emit('create', this.parsedMessage);
      this.loading = true;
    },
    hideModal() {
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss">
.break-word {
  overflow-wrap: break-word;
}
</style>
